import React from 'react';

import useLearnToSwimClubsCombobox from './UseLearnToSwimClubsCombobox';

import Combobox from '@usas/ui-web/components/comboboxes/Combobox';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LearnToSwimClubsCombobox = ({ label, name, valueToMatch, error, message, onChange }) => {
  const { ltsClubsState } = useLearnToSwimClubsCombobox();

  return ltsClubsState.message
    ? <span className={global.LoadingMsg}>{ltsClubsState.message}</span>
    : <Combobox
      label={label}
      name={name}
      isLoading={ltsClubsState.isArrayLoading}
      items={ltsClubsState.items}
      valueToMatch={valueToMatch}
      error={error}
      message={message}
      onChange={onChange} />
};

export default LearnToSwimClubsCombobox;